import dayjs from 'dayjs';
import { useState } from 'react';

type Props = {
  initial?: string;
  last?: string;
};

export const useDatesValidation = ({ initial = '', last = '' }: Props) => {
  const [dates, setDates] = useState<{ initial: string; last: string }>({
    initial,
    last,
  });
  const [disabled, setDisabled] = useState(true);

  const handleDates = async (id: string, date: any) => {
    setDates((prev) => ({ ...prev, [id]: dayjs(date).format('YYYY-MM-DD') }));
    if (id === 'initial') {
      setDisabled(false);
    }
  };

  const disableDates = (date: any) => {
    const dateTransform = dayjs(dates.initial);

    return dayjs(date).isBefore(dateTransform);
  };

  return { disableDates, handleDates, disabled, dates };
};
